







































import { Component, Emit, Prop, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { DataTable, Col } from '@/components/molecules/DataTable'
import { SystemCode } from '@/api'
import { UserNote } from '@/api/models/user'
import { cloneDeep, each } from 'lodash'

@Component({
  components: { DataTable }
})
export default class UserNotesEditTable extends ComponentVue {
  @Prop({
    type: Array,
    required: true
  })
  codes!: SystemCode[]

  @Prop({
    type: Array,
    required: true
  })
  items!: UserNote[]

  @Prop({
    type: Number
  })
  height!: number

  internalItems: UserNote[] = []

  @Watch('items', { immediate: true, deep: true })
  changeNoteItems(): void {
    this.internalItems = []
    each(this.items, (item: UserNote) => {
      this.internalItems.push(cloneDeep(item))
    })
  }

  get cols(): Col[] {
    return [
      {
        width: 50,
        items: [
          {
            name: 'descNo',
            align: 'right'
          }
        ]
      },
      {
        width: '50',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'note',
            headerText: '内容'
          }
        ]
      },
      {
        width: '25',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'date',
            headerText: '処理日'
          }
        ]
      },
      {
        width: '25',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'place',
            headerText: '処理場所'
          }
        ]
      },
      {
        width: 75,
        resizable: true,
        movable: true,
        items: [
          {
            name: 'detail',
            align: 'center'
          }
        ]
      },
      {
        width: 30,
        resizable: true,
        movable: true,
        items: [
          {
            name: 'remove',
            align: 'center'
          }
        ]
      }
    ]
  }

  focus(index: number) {
    console.log(index)
    // eslint-disable-next-line standard/computed-property-even-spacing
    const noteTextField: any = this.$refs[`noteTextField${index}`]

    if (!noteTextField) return

    noteTextField.atomTextField.focus()
  }

  onInputNote(systemCode: SystemCode, index: number) {
    this.debug('onInputNote', systemCode, index)
    this.$emit('input:note', systemCode, index)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  @Emit('click:detail')
  onClickDetail(index: number): number {
    return index
  }

  @Emit('click:remove')
  onClickRemove(index: number): number {
    return index
  }

  @Emit('click:add')
  onClickAddRow(): void {}
}
